import { Component, ElementRef, HostListener, Input, OnInit, SecurityContext, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {MatStepper, MatStepperModule} from '@angular/material/stepper';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import Swal from 'sweetalert2';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {CommonModule} from '@angular/common';
import {MatSelectModule} from '@angular/material/select';
import {MatOptionModule} from '@angular/material/core';
import {MatTooltipModule} from '@angular/material/tooltip';
import {HeaderComponent} from '../../header/header.component';
import {FooterComponent} from '../../footer/footer.component';
import {DireccionDirective} from '../../../validaciones/directives/direccion.directive';
import {NameDirective} from '../../../validaciones/directives/name.directive';
import {NumericDirective} from '../../../validaciones/directives/numeric.directive';
import {AlphanumericDirective} from '../../../validaciones/directives/alphanumeric.directive';
import {PlacaDirective} from '../../../validaciones/directives/placa.directive';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {MatIconModule} from '@angular/material/icon';
import {validadorReutilizable} from '../../../shared/utils/validadores';
import {SolicitudVo} from '../../../pojos/solicitudVo';
import {combineLatest, debounceTime, distinctUntilChanged, filter, startWith, Subscription} from 'rxjs';
import { EstatusVehiculoResponse } from '../../../pojos/estatusVehiculoResponse';
import { CatEfectoCertificado } from '../../../service/catEfectoCertificado.service';
import { CatCoberturaCertificados } from '../../../service/catCoberturaCertificados.service';
import { HttpErrorResponse, HttpEvent, HttpEventType } from '@angular/common/http';
import { DefaultErrorMessage, ErrorMessages } from '../../catalogoErrores/error-messages';
import { ResponsePropietarioFisica } from '../../../pojos/responsePropietarioFisica';
import { ImprimirSolicitudCdniGenerico } from '../../../service/imprimirSolicitudCdniGenerico.service';
import { DocumentoService } from '../../../service/cargarDocumentos.service';
import { EliminarDocumentos } from '../../../service/eliminarDocumentos.service';
import { ActivatedRoute } from '@angular/router';
import { EditarSolicitudEstatalFisica } from '../../../service/editarSolicitudEstatalFisica.service';
import { Documento, EstatusVehiculoResponseEdicion } from '../../../pojos/estatusVehiculoResponseEdicion';
import { GuardarCambiosEdicionEstatalFisica } from '../../../service/guardarCambiosEdicionEstatalFisica.service';
import { DocumentoTramite } from '../../../pojos/documentoTramiteForaneaVo';

@Component({
  selector: 'app-persona-fisica-estatal-edicion',
  imports: [ReactiveFormsModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatOptionModule,
    HeaderComponent,
    FooterComponent,
    MatCheckboxModule,
    FormsModule,
    CommonModule,
    MatSelectModule,
    MatTooltipModule,
    MatIconModule,

    DireccionDirective,
    NameDirective,
    NumericDirective,
    AlphanumericDirective,
    PlacaDirective,],
  templateUrl: './persona-fisica-estatal-edicion.component.html',
  styleUrl: './persona-fisica-estatal-edicion.component.css'
})
export class PersonaFisicaEstatalEdicionComponent {
 @ViewChild('stepper') stepper!: MatStepper;

  @Input() solicitudVo!: SolicitudVo;
  @Input() estatusVehiculoResponse!: EstatusVehiculoResponse;
  @Input() estatusVehiculoResponseEdicion!: EstatusVehiculoResponseEdicion;
  @Input() efectosCertificados: any[] = [];
  @Input() coberturaCertificados: any[] = [];
  uploadProgress: number[] = [0, 0, 0, 0];
  isUploading: boolean[] = [false, false, false, false];
  documentos = [
    {id: 8, titulo: 'SOLICITUD DEL TRAMITE', formControlName: '',estadoSubida: 'PENDIENTE', urlVisor: '', rawUrl: ''},
    {id: 3, titulo: 'FACTURA', formControlName: '', estadoSubida: 'PENDIENTE', urlVisor: '', rawUrl: ''},
    {id: 4, titulo: 'INE', formControlName: '', estadoSubida: 'PENDIENTE', urlVisor: '', rawUrl: ''},
    {id: 7, titulo: 'REPUVE', formControlName: '', estadoSubida: 'PENDIENTE', urlVisor: '', rawUrl: ''},
  ];
  nombreArchivos: string[] = ['', '', '', ''];
  documentosSubidos: { identificador: string; idDocumento: number; }[] = [];
  identificadoresAnteriores: string[] = []; // <-- ya lo manejas por índice
  idsDocumentoAnteriores: number[] = [];   // <-- también por índice

  dataParam: string | null = null;
  checkboxSolicitud: boolean = false;
  checkboxFactura: boolean = false;
  checkboxINE: boolean = false;
  checkboxRepuve: boolean = false;
  idSolicitud = 0;
  idFactura = 0;
  idINE = 0;
  idRepuve = 0;
  @Input() documentoList: DocumentoTramite[] = [];
  btnSubirPdf: boolean = false;
  //********************************************* INICIALIZADOR DE FORMGROUP ************************************************//

  PrimerFormGroup!: FormGroup;
  SegundoGrupo!: FormGroup;
  TercerFormGroup!: FormGroup;
  CuartoFormGroup!: FormGroup;
  QuintoFormGroup!: FormGroup;
  SextoFormGroup!: FormGroup;

  mostrarSpinner = false;
  isLinear = false;

  //********************************************* VARIABLES INICIALIZADAS PARA DOCUMENTOS PDF - IFRAME ************************************************//

  // SOLICITUD
  archivoPDF1: File | null = null;
  pdfURL1: any = null;
  // isUploading = false;
  // uploadProgress = 0;

  // FACTURA
  archivoPDF2: File | null = null;
  pdfURL2: any = null;
  isUploading2 = false;
  uploadProgress2 = 0;

  // INE
  archivoPDF3: File | null = null;
  pdfURL3: any = null;
  isUploading3 = false;
  uploadProgress3 = 0;

  // REPUVE
  archivoPDF4: File | null = null;
  pdfURL4: any = null;
  isUploading4 = false;
  uploadProgress4 = 0;
  subscription!: Subscription;
  bolHomoClaveCampo = false;
  bolDisableCampo = false;

  constructor(
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private editarSolicitudEstatalService: EditarSolicitudEstatalFisica,
    private catEfectoCertificadoService: CatEfectoCertificado,
    private catCoberturaCertificadoService: CatCoberturaCertificados,
    private guardarEdicionEstatalFisica: GuardarCambiosEdicionEstatalFisica,
    private imprimirSolicitudCdniGenerico: ImprimirSolicitudCdniGenerico,
    private cargarDocumentosService: DocumentoService,
    private eliminarDocumentosService: EliminarDocumentos
  ) {

     this.solicitudVo = new SolicitudVo();
      this.catCoberturaCertificados();
      this.catEfectoCertificado();
  }


  //********************************************* VARIABLES INICIALIZADAS PARA VALIDAR CAMPOS VACIOS ************************************************//

  ngOnInit(): void {

    this.PrimerFormGroup = this._formBuilder.group({
      niv: [{value: '', disabled: true}],
      placa: [{value: '', disabled: true}],

      motivoSolicitud: [{value: '', disabled: true}],
      certificadoPor: [{value: '', disabled: true}],
      tipoServicio: [{value: '', disabled: true}],
      categoria: [{value: '', disabled: true}],
      marca: [{value: '', disabled: true}],
      submarca: [{value: '', disabled: true}],
      modelo: [{value: '', disabled: true}],
      motor: [{value: '', disabled: true}],
      refrendo: [{value: '', disabled: true}],
      repuve: [{value: '', disabled: true}],
    });

    this.SegundoGrupo = this._formBuilder.group({
      rfc: [{value: '', disabled: true}],

      curp: [{value: '', disabled: true},[
          Validators.minLength(18),
          Validators.maxLength(18),
          Validators.pattern(
            /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/
          ),
          validadorReutilizable({
            blnPermitirLetras: true,
            blnPermitirNumeros: true,
            intLongitudMaxima: 18,
            blnPermitirEspacios: false,
            blnPermitirAcentos: false,
            blnPermitirPuntos: false,
            blnPermitirCaracteresEspecialesDireccion: false,
            blnPermitirCaracteresEspecialesEmpresa: false,
            strCompararConCampo: 'rfc', // Haz referencia al RFC
            strMensajeComparacion: 'Los primeros 10 caracteres del RFC y CURP no coinciden.',
            blnEsCURP: true,
          })
        ],
      ],
      nombre: [{value: '', disabled: true}],
      apellidoPaterno: [{value: '', disabled: true}],
      apellidoMaterno: [{value: '', disabled: true}],
      sexo: [{value: '', disabled: true}],
      fechaNacimiento: [{value: '', disabled: true}],
      calle: [{value: '', disabled: true}],
      numeroExterior: [{value: '', disabled: true}],
      numeroInterior: [{value: '', disabled: true}],
      codigoPostal: [{value: '', disabled: true}],
      estado: [{value: '', disabled: true}],
      municipio: [{value: '', disabled: true}],
      localidad: [{value: '', disabled: true}],
    });

    this.TercerFormGroup = this._formBuilder.group({
      numeroTelefono: [{value: '', disabled: true},[ Validators.pattern(/^\d{10}$/)],],
      correoElectronico: [{value: '', disabled: true},[Validators.pattern(/^[a-zA-Z0-9._%+-]{3,}@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/),],],
    });

    this.CuartoFormGroup = this._formBuilder.group({
      descargarDocumento: [false, Validators.requiredTrue],
    });


    this.QuintoFormGroup = this._formBuilder.group({
     solicitud: [false, Validators.requiredTrue],
  factura: [false, Validators.requiredTrue],
  ine: [false, Validators.requiredTrue],
  repuveDoc: [false, Validators.requiredTrue]
    });

    this.SextoFormGroup = this._formBuilder.group({
      terminosCondiciones: [false, Validators.requiredTrue],
    });

  //********************************************* VALIDACIONES REACTIVAS 1-3 ************************************************//

    // 🔹 Aplicamos validaciones en tiempo real a TODOS los formularios
    this.inicializarValidacionesReactivas(this.PrimerFormGroup);
    this.inicializarValidacionesReactivas(this.SegundoGrupo);
    this.inicializarValidacionesReactivas(this.TercerFormGroup);
    this.inicializarValidacionesReactivas(this.CuartoFormGroup);
    this.inicializarValidacionesReactivas(this.QuintoFormGroup);
    this.inicializarValidacionesReactivas(this.SextoFormGroup);
//********************************************* VALIDACIONES DE CAMPOS 1-2 ************************************************//

//********************************************* VALIDACION DE NIV Y PLACA PARA OBTENER ESOS VALORES ************************************************//
//********************************************* VALIDACION DE NIV Y PLACA PARA OBTENER ESOS VALORES ************************************************//
//********************************************* VALIDACION DE RFC, HOMOCLAVE, CURP PARA OBTENER LOS VALORES Y CONSUMO DE SERVICIO *****************//
//********************************************* VALIDACION DE RFC, HOMOCLAVE, CURP PARA OBTENER LOS VALORES Y CONSUMO DE SERVICIO ****************//
    this.dataParam = this.route.snapshot.paramMap.get('data');
    

    this.obtenerDatosEditarEstatal(this.dataParam?.substring(5));
  }


  //******************METODOS y llamada a consumos de servicio********************************//
  obtenerDatosEditarEstatal(data:any){
    this.mostrarSpinner = true;
    this.editarSolicitudEstatalService.editarEstatalFisica(this.dataParam?.substring(5)).subscribe({
      next: (resp:EstatusVehiculoResponseEdicion) => {
        this.estatusVehiculoResponseEdicion = resp;

        // Limpiar el formulario primero para evitar que los campos se queden sucios
          this.PrimerFormGroup.patchValue({
            categoria: '',
            marca: '',
            submarca: '',
            modelo: '',
            motor: '',
            refrendo: '',
            repuve: ''
          });

         this.PrimerFormGroup.patchValue({
          niv:this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.strNiv,
          placa: this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.strPlaca,
          motivoSolicitud: this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.intIdMotivoSolicitud,
          certificadoPor: this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.intIdCertificadoPor,
          tipoServicio: this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.intIdTipoServicio,
          categoria: this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.strCategoria,
          marca: this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.strMarca,
          submarca: this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.strSubMarca,
          modelo: this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.strModelo,
          motor: this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.strNoMotor,
          refrendo: this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.strAnioRefrendo,
          repuve: this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.strRepuve
        });

        this.SegundoGrupo.patchValue({
          rfc: this.estatusVehiculoResponseEdicion.datosPersonaResponseVo.strRfc,
          curp: this.estatusVehiculoResponseEdicion.datosPersonaResponseVo.strCurp,
          nombre: this.estatusVehiculoResponseEdicion.datosPersonaResponseVo.strNombre,
          apellidoPaterno: this.estatusVehiculoResponseEdicion.datosPersonaResponseVo.strApPaterno,
          apellidoMaterno: this.estatusVehiculoResponseEdicion.datosPersonaResponseVo.strApMaterno,
          sexo: this.estatusVehiculoResponseEdicion.datosPersonaResponseVo.strSexo,
          fechaNacimiento: this.estatusVehiculoResponseEdicion.datosPersonaResponseVo.strFechaNacimiento,
          calle: this.estatusVehiculoResponseEdicion.datosDomicilioResponseVo.strCalle,
          numeroExterior: this.estatusVehiculoResponseEdicion.datosDomicilioResponseVo.strNoExterior,
          numeroInterior: this.estatusVehiculoResponseEdicion.datosDomicilioResponseVo.strNoInterior,
          codigoPostal: this.estatusVehiculoResponseEdicion.datosDomicilioResponseVo.strCodigoPostal,
          estado: this.estatusVehiculoResponseEdicion.datosDomicilioResponseVo.strEstado,
          municipio: this.estatusVehiculoResponseEdicion.datosDomicilioResponseVo.strMunicipio,
          localidad: this.estatusVehiculoResponseEdicion.datosDomicilioResponseVo.strLocalidad
        });

        this.TercerFormGroup.patchValue({
          numeroTelefono: this.estatusVehiculoResponseEdicion.datosDeContactoResponseVo.strTelefono,
          correoElectronico: this.estatusVehiculoResponseEdicion.datosDeContactoResponseVo.strCorreoElectronico
        });


        this.mostrarPDF(this.estatusVehiculoResponseEdicion.documentoList ?? []);
        this.extractBirthday();
        this.extraerSexoDesdeCurp();


        this.mostrarSpinner = false;
      },
      error: (error: HttpErrorResponse) =>{

      this.mostrarSpinner = false;
    let message = DefaultErrorMessage;

    if(error instanceof HttpErrorResponse){
      const statusCode = error.status;

      // Si viene un código de error personalizado desde el backend:
        const customCode = error.error?.codigo; // <- Esto depende de tu backend

        if(customCode && ErrorMessages[customCode]){
            message = ErrorMessages[customCode];
        }else if (ErrorMessages[statusCode]) {
          message = ErrorMessages[statusCode];
        }
      }
     Swal.fire({
        icon: 'error',
        title: 'Error',
        text: message,

    }).then(() => {
                ;// Recargar la página después de confirmar
              });

    }
    })
  }


 catCoberturaCertificados(){
  this.catCoberturaCertificadoService.catCoberturaCertificado().subscribe({
    next: (data:any) => {
      this.coberturaCertificados = data;
    }
  });
 }


catEfectoCertificado(){
  this.catEfectoCertificadoService.catEfectoCertificado().subscribe({
    next: (data: any) => {
      this.efectosCertificados = data;
    }
  });
}


onChangeCoberturaCertificados(event:any){
  this.solicitudVo.strCertificadoPor = event.target.value;
}


onChangeEfectoCertificado(event:any){
  this.solicitudVo.strMotivoSolicitud = event.target.value;
}

onChangeTipoServicio(event:any){
  this.solicitudVo.strTipoServicio = event.target.value;
}




subirDocumento(rfc: string, idDocumento: number, archivo: File): void {
  //this.documentos[index].estadoSubida ='SUBIENDO';
     const doc = this.documentos.find(d => d.id === idDocumento);
  if (!doc) {
    console.error('Documento no encontrado con id:', idDocumento);
    return;
  }
  this.cargarDocumentosService.subirDocumentoPdf(rfc, idDocumento, archivo).subscribe({
    next: (event: HttpEvent<any>) => {
      if (event.type === HttpEventType.UploadProgress && event.total){
        const progreso = Math.round((100 * event.loaded) / event.total);
       // this.isUploading[index] = true;
       //this.uploadProgress[index] = progreso;
      } else if (event.type === HttpEventType.Response) {
       //this.isUploading[index] = false;

       //this.documentos[index].estadoSubida = 'SUBIDO';
        const respuesta = event.body; // Aquí accedes a la respuesta del servicio

        // this.identificadoresAnteriores[index] = respuesta.identificador;
        // this.idsDocumentoAnteriores[index] = respuesta.idDocumento;


        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: `${doc.titulo} subido con éxito`,
          showConfirmButton: false,
          timer: 3000
        });
      }
    },
    error: () => {
      //this.isUploading[index] = false;
      //this.documentos[index].estadoSubida = 'ERROR';
     Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        title: `No se pudo subir el documento ${doc.titulo}.`,
        showConfirmButton: false,
        timer: 3000
      });
    }
  });
}

  mostrarPDF(documentos: Documento[]){
    documentos.forEach(doc => {
      const urlDescarga = `https://af-documentos-pdf-cdni.sefintlax.gob.mx/${doc.url.substring(20)}`;
      const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(urlDescarga);
      const estatusBool = doc.estatus === 'true';


      switch (doc.idDocumentoTramite) {
          case 8: //SOLICITUD
          this.pdfURL1 = safeUrl;
          this.archivoPDF1 = new File(['placeholder'], doc.nombreDocumento || 'solicitud.pdf', {
          type: 'application/pdf',
          });
          this.checkboxSolicitud = estatusBool;
          this.idSolicitud = doc.idDocumento;
          this.QuintoFormGroup.get('solicitud')?.setValue(estatusBool);
          this.QuintoFormGroup.get('solicitud')?.setValue(true); // o false, según `estatusBool`
          break;

          case 3: //FATURA
          this.pdfURL2 = safeUrl;
         this.archivoPDF2 = new File(['placeholder'], doc.nombreDocumento || 'factura.pdf', {
          type: 'application/pdf',
        });
          this.checkboxFactura = estatusBool;
          this.idFactura = doc.idDocumento;
          this.QuintoFormGroup.get('factura')?.setValue(estatusBool);
          this.QuintoFormGroup.get('factura')?.setValue(true); // o false, según `estatusBool`
          break;

          case 4: //INE
          this.pdfURL3 = safeUrl;
          this.archivoPDF3 = new File(['placeholder'], doc.nombreDocumento || 'ine.pdf', {
          type: 'application/pdf',
        });
          this.checkboxINE = estatusBool;
          this.idINE = doc.idDocumento;
          this.QuintoFormGroup.get('ine')?.setValue(estatusBool);
          this.QuintoFormGroup.get('ine')?.setValue(true); // o false, según `estatusBool`
          break;

          case 7: //REPUVE
          this.pdfURL4 = safeUrl;
          this.archivoPDF4 = new File(['placeholder'], doc.nombreDocumento || 'repuve.pdf', {
          type: 'application/pdf',
        });
          this.checkboxRepuve = estatusBool;
          this.idRepuve = doc.idDocumento;
          this.QuintoFormGroup.get('repuveDoc')?.setValue(estatusBool);
          this.QuintoFormGroup.get('repuveDoc')?.setValue(true); // o false, según `estatusBool`

          break;
      }
    });

    this.documentoList = documentos.map(doc => ({
      idDocumento: doc.idDocumento,
      url: doc.url,
      idDocumentoTramite: doc.idDocumentoTramite,
      nombreDocumento: doc.nombreDocumento,
      estadoSubida: 'SUBIDO' // 👈 marcamos que ya está subido si viene del backend
    }));


  }

obtenerUrlRelativa(url: any): string {
  const trustedUrl = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, url);
  if (trustedUrl) {
    const index = trustedUrl.indexOf('uploads/');
    return index !== -1 ? trustedUrl.substring(index) : '';
  }
  return '';
}
 //******************METODOS y llamada a consumos de servicio********************************//






  //********************************************* VALIDACIONES REACTIVAS 2-3 ************************************************//

  private inicializarValidacionesReactivas(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((campo) => {
      formGroup.get(campo)?.valueChanges.subscribe(() => {
        this.actualizarEstilosCampo(campo);
      });
    });
  }

  //********************************************* VALIDACIONES REACTIVAS 3-3 ************************************************//

  private actualizarEstilosCampo(campo: string) {
    const control =
      this.SextoFormGroup.get(campo) ||
      this.QuintoFormGroup.get(campo) ||
      this.CuartoFormGroup.get(campo) ||
      this.TercerFormGroup.get(campo) ||
      this.SegundoGrupo.get(campo) ||
      this.PrimerFormGroup.get(campo);

      if (!control || control.disabled) return;

    const fieldElement = document.querySelector(`[formControlName="${campo}"]`);

    if (fieldElement) {
      if (control?.valid) {
        fieldElement.classList.remove('is-invalid');
        fieldElement.classList.add('is-valid');
      } else {
        fieldElement.classList.add('is-invalid');
        fieldElement.classList.remove('is-valid');
      }
    }
  }

  //********************************************* STEPPER ************************************************//

  /** Validación y navegación **/
  validarYContinuar(campos: { grupo: FormGroup; nombres: string[] }) {
    let todosValidos = true;

    campos.nombres.forEach((campo) => {
      const control = campos.grupo.get(campo);
      const fieldElement = document.querySelector(
        `[formControlName="${campo}"]`
      );
      if(control){
        control.markAsTouched({onlySelf: true});
        control.updateValueAndValidity();
      }

      if (control && control.disabled) return;

      if (control && control.invalid && !control.disabled) {
        todosValidos = false;
        Swal.fire({
          html: this.mensajeError(campo),
          icon: 'warning',
          confirmButtonColor: '#A11A5C',
          confirmButtonText: 'Confirmar',
          didOpen: () => fieldElement?.classList.add('is-invalid'),
        });
      } else if (fieldElement && (control?.valid || control?.disabled)) {
        fieldElement.classList.remove('is-invalid');
        fieldElement.classList.add('is-valid');
      }
    });

    if (todosValidos) this.stepper.next();
  }

  //********************************************* MENSAJES PERSONALIZADOS ************************************************//

  mensajeError(campo: string): string {
    const mensajes: any = {
      niv: 'El campo <b> NIV de los Datos del Vehículo </b> no debe estar vacío.',
      placa:
        'El campo <b> Placa de los Datos del Vehículo </b> no debe estar vacío.',
      motivoSolicitud:
        'El campo <b> Motivo Solicitud de los Datos del Vehículo </b> debe estar seleccionado.',
      certificadoPor:
        'El campo <b> Certificado Por: de los Datos del Vehículo </b> debe estar seleccionado.',
      tipoServicio:
        'El campo <b> Tipo Servicio de los Datos del Vehículo </b> debe estar seleccionado.',
      rfc:
        'Por favor verifica que el campo <b> RFC </b> ' +
        'no este vacío o que el formato proporcionado sea válido.' +
        '<br>' +
        '<b> formato válido: </b> LLLL000000AAA',
        homoClave:
        'Por favor verifica que el campo <b> HOMOCLAVE </b> ' +
        'no este vacío o que el formato proporcionado sea válido.' +
        '<br>',
      curp:
        'Por favor verifica que el campo <b> CURP </b> ' +
        'no este vacío o que el formato proporcionado sea válido.' +
        '<br>' +
        '<b> formato válido: </b> LLLL000000LLLLLLA0',
      correoElectronico:
        'Por favor verifica que el campo <b> Correo Electrónico de los Medios de Contacto </b> ' +
        'no este vacío o que el formato proporcionado sea válido.' +
        '<br>' +
        '<b> formato correo: </b> nombre@ejemplo.com',
      numeroTelefono:
        'El campo <b> Número Teléfono de los Medios de Contacto </b> debe contener 10 números.',
      descargarDocumento:
        'Para continuar a la sección de <b>Documentos</b> primero debes marcar el cuadro que aparece en la parte inferior de esta sección',
      solicitud: 'El documento <b>SOLICITUD</b> no ha sido seleccionado',
      factura: 'El documento <b>FACTURA</b> no ha sido seleccionado',
      ine: 'El documento <b>INE</b> no ha sido seleccionado',
      repuve: 'El documento <b>REPUVE</b> no ha sido seleccionado',
    };

    return mensajes[campo] || 'Campo inválido.';
  }

//***********************************************VALIDACIONES DE CAMPOS 2-2**********************************************//
  readonly camposDependientesVehiculo = [
    'categoria', 'marca', 'submarca', 'modelo',
    'motor', 'refrendo', 'repuve'
  ];

  marcarCamposVehiculoComoValidos(): void {
    this.camposDependientesVehiculo.forEach(campo => {
      const control = this.PrimerFormGroup.get(campo);
      if (control && control.disabled) {
      }
      control?.setErrors(null);
      control?.markAsTouched();
      control?.markAsDirty();
    });
  }

  resetearCamposVehiculo(): void {
    this.camposDependientesVehiculo.forEach(campo => {
      const control = this.PrimerFormGroup.get(campo);
      control?.reset({value: '', disabled: true});
    });
  }







  //********************************************* BOTONES SIGUIENTE ************************************************//

  nextButtonClick() {


    this.validarYContinuar({
      grupo: this.PrimerFormGroup,
      nombres: [
        'tipoServicio',
        'certificadoPor',
        'motivoSolicitud',
        'placa',
        'niv',
      ],
    });
  }

  nextButtonClick2() {
    this.validarYContinuar({
      grupo: this.SegundoGrupo,
      nombres: ['curp','homoClave', 'rfc'],
    });
  }

  nextButtonClick3() {
    this.validarYContinuar({
      grupo: this.TercerFormGroup,
      nombres: ['correoElectronico', 'numeroTelefono'],
    });
  }

  nextButtonClick4() {
    this.validarYContinuar({
      grupo: this.CuartoFormGroup,
      nombres: ['descargarDocumento'],
    });
  }

  nextButtonClick5() {
    const errores: string[] = [];

  if (!this.archivoPDF1 || this.archivoPDF1.size === 0) errores.push('SOLICITUD');
  if (!this.archivoPDF2 || this.archivoPDF2.size === 0) errores.push('FACTURA');
  if (!this.archivoPDF3 || this.archivoPDF3.size === 0) errores.push('INE');
  if (!this.archivoPDF4 || this.archivoPDF4.size === 0) errores.push('REPUVE');

  if (errores.length > 0) {
    Swal.fire({
      icon: 'warning',
      title: 'Falta documento',
      html: `El documento <strong>${errores[0]}</strong> no ha sido seleccionado.`,
      confirmButtonColor: '#6c63ff',
    });
    return;
  }
    this.validarYContinuar({
      grupo: this.QuintoFormGroup,
      nombres: ['repuve', 'ine', 'factura', 'solicitud'],
    });
  }

   descargarDocumento() {

      const primerGrupo = this.PrimerFormGroup.getRawValue();
      const segundoGrupo = this.SegundoGrupo.getRawValue();

      const strNombreCompleto = `${segundoGrupo.nombre || ''} ${segundoGrupo.apellidoPaterno || ''} ${segundoGrupo.apellidoMaterno || ''}`.trim();
      const strRfc = `${segundoGrupo.rfc}${segundoGrupo.homoClave}`.trim();
      const strCurp = segundoGrupo.curp || '';

      const calle = segundoGrupo.calle || '';
      const numExt = segundoGrupo.numeroExterior || '';
      const numInt = segundoGrupo.numeroInterior || '';
      const codigoPostal = segundoGrupo.codigoPostal || '';
      const strDomicilio = `${calle} ${numExt}${numInt ? ' Int ' + numInt : ''}${codigoPostal}`.trim();

      const strMunicipio = segundoGrupo.municipio || '';
      const strEstado = segundoGrupo.estado || '';

      const strGarantias = primerGrupo.motivoSolicitud || '';
      const strNiv = primerGrupo.niv || '';
      const strPlaca = primerGrupo.placa || '';
      const strMarca = primerGrupo.marca || '';
      const strEstadoVehiculo = segundoGrupo.estado || '';
      const strModelo = primerGrupo.modelo || '';
      const strRefrendo = primerGrupo.refrendo || '';
      const strTipoServicio = primerGrupo.tipoServicio || '';
      const strNumeroMotor = primerGrupo.motor || '';
      const strRepuve = primerGrupo.repuve || '';
      const strRazonSocial = '';
      const strRfcRepresentante = '';
      const strTipoPersona = 'F';

    Swal.fire({
      html: `<h4>Descargando documento <b style="color: #A11A5C">SOLICITUD DE CERTIFICADO DE NO INFRACCIÓN</b><hr>espere un momento...</h4>`,
      didOpen: () => {
        Swal.showLoading();
      },
      timer: 4000,
      timerProgressBar: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
    });

    
    this.imprimirSolicitudCdniGenerico.imprimirSolicitudCdniGenerico(
    strNombreCompleto,
    strRfc,
    strRfcRepresentante,
    strRazonSocial,
    strCurp,
    strDomicilio,
    strMunicipio,
    strEstado,
    strGarantias,
    strNiv,
    strPlaca,
    strMarca,
    strEstadoVehiculo,
    strModelo,
    strRefrendo,
    strTipoServicio,
    strNumeroMotor,
    strRepuve,
    strTipoPersona).subscribe({
      next: (blob: Blob) =>{
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'solicitud_cdni_estatal.pdf';
        a.click();
        window.URL.revokeObjectURL(url);
        Swal.close();
      },
       error: (error) => {
      Swal.fire('Error', 'No se pudo generar el documento. Por favor, inténtelo de nuevo más tarde.', 'error');
    }
    });

  }


  nextButtonClick6() {

    this.validarYContinuar({
      grupo: this.SextoFormGroup,
      nombres: ['terminosCondiciones'],
    });

    const campo1 = this.SextoFormGroup.get('terminosCondiciones');

    const correo = this.TercerFormGroup.get('correoElectronico')?.value;

    if (campo1 && !campo1.value) {
      Swal.fire({
        html: '<b>Debes Aceptar los Términos y Condiciones</b>',
        icon: 'warning',
        confirmButtonColor: '#A11A5C',
        confirmButtonText: 'Confirmar',
      });
      return;
    }

      const payload = {
        "dataEncript": this.dataParam?.substring(5),
        "documentoList": this.documentoList
      }

    Swal.fire({
      title: '¿Estás seguro que deseas guardar la información?',
      icon: 'question',
      confirmButtonColor: '#04B404',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      showCancelButton: true,
      allowOutsideClick: false,
    }).then((result) => {
      if (result.value) {
        this.mostrarSpinner = true;
        this.guardarEdicionEstatalFisica.guardarEdicionEstatalFisica(payload).subscribe({
        next: (res: ResponsePropietarioFisica) => {
          if(res.intCodigoHttp === 200){
          Swal.fire({
          icon: 'success',
          title: 'Solicitud enviada',
          html: `Su solicitud ha sido enviada correctamente. <br><br>
         Se ha enviado un correo electrónico a la dirección proporcionada <b style="color: #A11A5C">${correo}</b> para darle seguimiento.
         <hr>Le recomendamos revisar su bandeja de entrada, así como la carpeta de spam o correo no deseado, en caso de no visualizar el mensaje.`,
          confirmButtonColor: '#04B404',
          confirmButtonText: 'Continuar',
          allowEscapeKey: false, // Deshabilita cerrar con ESC
          allowEnterKey: false, // Deshabilita cerrar con ENTER
          allowOutsideClick: false, // Deshabilita cerrar haciendo clic fuera
        });
          }else if (res.intCodigoHttp === 400) {
             Swal.fire({
            icon: 'error',
            title: 'Error al enviar datos',
            html: '<h4>No se pudo generar la solicitud. Verifique su información e inténtelo de nuevo.<br>Gracias.</p>',
            });
          }
          this.mostrarSpinner = false;
        },
        error: (error: HttpErrorResponse) =>{
                        this.mostrarSpinner = false;
                      let message = DefaultErrorMessage;

                      if(error instanceof HttpErrorResponse){
                        const statusCode = error.status;

                        // Si viene un código de error personalizado desde el backend:
                          const customCode = error.error?.codigo; // <- Esto depende de tu backend

                          if(customCode && ErrorMessages[customCode]){
                              message = ErrorMessages[customCode];
                          }else if (ErrorMessages[statusCode]) {
                            message = ErrorMessages[statusCode];
                          }
                        }
                      Swal.fire({
                          icon: 'error',
                          title: 'Error',
                          text: message,
                      }).then(() => {
                                  location.reload(); // Recargar la página después de confirmar
                                });
                      }
      })
      }
    });
  }

  //********************************** SOLICITUD *********************************************//

  onFileSelecteded1(input: HTMLInputElement, idDocumentoTramite: number): void {
    const file = input.files?.[0];

    const maxSizeMB = 2;
    const maxSizeBytes = maxSizeMB * 1024 * 1024;

    if (file) {
      if (file.type !== 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Tipo de archivo no válido',
          text: 'Por favor selecciona un archivo PDF.',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      if (file.size > maxSizeBytes) {
        Swal.fire({
          icon: 'error',
          title: 'Archivo demasiado grande',
          text: `El archivo supera el límite de ${maxSizeMB} MB.`,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }        

      const datosPersona = this.SegundoGrupo.getRawValue();
      
      const rfc = datosPersona.rfc || '';

      const objectUrl = URL.createObjectURL(file);
      const pdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);

      //const existente  = this.documentoList.find(doc => doc.idDocumentoTramite === idDocumentoTramite);

       // Buscar si ya hay documento anterior cargado para este tipo
        const existente = this.documentoList.find(doc => doc.idDocumentoTramite === idDocumentoTramite);

  if (existente) {
    // Llamar a servicio para eliminar el documento existente
    Swal.fire({
    title: '¿Reemplazar archivo?',
    text: `Ya existe un archivo para "SOLICITUD DEL TRAMITE". ¿Deseas eliminar el anterior y subir el nuevo?`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#41bd00',
    cancelButtonColor: '#C71128',
    confirmButtonText: 'Sí, reemplazar',
    cancelButtonText: 'No, cancelar'
  }).then((result) => {
    if(result.isConfirmed){

      this.archivoPDF1 = file;
      this.pdfURL1 = pdfSafeUrl;

    this.eliminarDocumentosService.eliminarDocumentos(existente.idDocumento, rfc, existente.nombreDocumento).subscribe({
      next: (res) => {
        if (res.status === 204) {

          this.subirDocumento(rfc, idDocumentoTramite, file); // 👈 Subir nuevo PDF
        } else {
          Swal.fire('Error', 'No se pudo eliminar el documento anterior.', 'error');
        }
      },
      error: (err) => {
        if (err.status === 404) {

          this.subirDocumento(rfc, idDocumentoTramite, file); // 👈 Subir de todos modos
        } else {
          Swal.fire('Error', 'Error al eliminar el documento anterior.', 'error');
        }
      }
    });
    }
  });
    
  } else {
    this.archivoPDF1 = file;
    this.pdfURL1 = pdfSafeUrl;
    // No había documento previo, subir directamente
    this.subirDocumento(rfc, idDocumentoTramite, file);
  }

}
}

  // Método para manejo de evento al seleccionar
  archivoSelecionadoPDF1(event: Event, index: number): void {
  }

  // Método para abrir el PDF en nueva ventana
  abrirPDFNewVentana1(): void {
    if (this.pdfURL1) {
      const url = this.pdfURL1 as SafeResourceUrl;
      //const url = URL.createObjectURL(this.archivoPDF1);
      window.open((url as any).changingThisBreaksApplicationSecurity, '_blank');
    } else {
      Swal.fire({
        icon: 'warning',
        title: '¡Aviso!',
        text: 'Para visualizar el documento, primero debes seleccionar uno.',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#A11A5C',
      });
    }
  }

  //********************************** FACTURA *********************************************//

  onFileSelecteded2(input: HTMLInputElement, idDocumentoTramite: number): void {
    const file = input.files?.[0];

    const maxSizeMB = 2;
    const maxSizeBytes = maxSizeMB * 1024 * 1024;

    if (file) {
      if (file.type !== 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Tipo de archivo no válido',
          text: 'Por favor selecciona un archivo PDF.',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      if (file.size > maxSizeBytes) {
        Swal.fire({
          icon: 'error',
          title: 'Archivo demasiado grande',
          text: `El archivo supera el límite de ${maxSizeMB} MB.`,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }


      const datosPersona = this.SegundoGrupo.getRawValue();
      
      const rfc = datosPersona.rfc || '';

      const objectUrl = URL.createObjectURL(file);
      const pdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);

      //const existente  = this.documentoList.find(doc => doc.idDocumentoTramite === idDocumentoTramite);

       // Buscar si ya hay documento anterior cargado para este tipo
        const existente = this.documentoList.find(doc => doc.idDocumentoTramite === idDocumentoTramite);

  if (existente) {
    Swal.fire({
    title: '¿Reemplazar archivo?',
    text: `Ya existe un archivo para "FACTURA". ¿Deseas eliminar el anterior y subir el nuevo?`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#41bd00',
    cancelButtonColor: '#C71128',
    confirmButtonText: 'Sí, reemplazar',
    cancelButtonText: 'No, cancelar'
    }).then((result) =>{
    if(result.isConfirmed){

      this.archivoPDF2 = file;
      this.pdfURL2 = pdfSafeUrl;

      this.eliminarDocumentosService.eliminarDocumentos(existente.idDocumento, rfc, existente.nombreDocumento).subscribe({
      next: (res) => {
        if (res.status === 204) {

          this.subirDocumento(rfc, idDocumentoTramite, file); // 👈 Subir nuevo PDF
        } else {
          Swal.fire('Error', 'No se pudo eliminar el documento anterior.', 'error');
        }
      },
      error: (err) => {
        if (err.status === 404) {

          this.subirDocumento(rfc, idDocumentoTramite, file); // 👈 Subir de todos modos
        } else {
          Swal.fire('Error', 'Error al eliminar el documento anterior.', 'error',);
        }
      }
    });
   }
  });
    // Llamar a servicio para eliminar el documento existente 
  } else {
    this.archivoPDF2 = file;
    this.pdfURL2 = pdfSafeUrl;
    // No había documento previo, subir directamente
    this.subirDocumento(rfc, idDocumentoTramite, file);
  }

    }
  }

  // Método para manejo de evento al seleccionar
  archivoSelecionadoPDF2(event: Event, index: number): void {
  }

  // Método para abrir el PDF en nueva ventana
  abrirPDFNewVentana2(): void {
    if (this.pdfURL2) {
      const url = this.pdfURL2 as SafeResourceUrl;
      window.open((url as any).changingThisBreaksApplicationSecurity, '_blank');
      //const url = URL.createObjectURL(this.archivoPDF2);
      //window.open(url, '_blank');
    } else {
      Swal.fire({
        icon: 'warning',
        title: '¡Aviso!',
        text: 'Para visualizar el documento, primero debes seleccionar uno.',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#A11A5C',
      });
    }
  }

  //********************************** INE *********************************************//

  onFileSelecteded3(input: HTMLInputElement, idDocumentoTramite: number): void {
    const file = input.files?.[0];

    const maxSizeMB = 2;
    const maxSizeBytes = maxSizeMB * 1024 * 1024;

    if (file) {
      if (file.type !== 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Tipo de archivo no válido',
          text: 'Por favor selecciona un archivo PDF.',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      if (file.size > maxSizeBytes) {
        Swal.fire({
          icon: 'error',
          title: 'Archivo demasiado grande',
          text: `El archivo supera el límite de ${maxSizeMB} MB.`,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      const datosPersona = this.SegundoGrupo.getRawValue();

      const rfc = datosPersona.rfc || '';
     
      const objectUrl = URL.createObjectURL(file);
      const pdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);

      //const existente  = this.documentoList.find(doc => doc.idDocumentoTramite === idDocumentoTramite);

       // Buscar si ya hay documento anterior cargado para este tipo
        const existente = this.documentoList.find(doc => doc.idDocumentoTramite === idDocumentoTramite);

        if (existente) {

          Swal.fire({
          title: '¿Reemplazar archivo?',
          text: `Ya existe un archivo para "INE". ¿Deseas eliminar el anterior y subir el nuevo?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#41bd00',
          cancelButtonColor: '#C71128',
          confirmButtonText: 'Sí, reemplazar',
          cancelButtonText: 'No, cancelar'
          }).then((result) =>{
            if(result.isConfirmed){

              this.archivoPDF3 = file;
              this.pdfURL3 = pdfSafeUrl;
               // Llamar a servicio para eliminar el documento existente
          this.eliminarDocumentosService.eliminarDocumentos(existente.idDocumento, rfc, existente.nombreDocumento).subscribe({
            next: (res) => {
              if (res.status === 204) {

                this.subirDocumento(rfc, idDocumentoTramite, file); // 👈 Subir nuevo PDF
              } else {
                Swal.fire('Error', 'No se pudo eliminar el documento anterior.', 'error');
              }
            },
            error: (err) => {
              if (err.status === 404) {

                this.subirDocumento(rfc, idDocumentoTramite, file); // 👈 Subir de todos modos
              } else {
                Swal.fire('Error', 'Error al eliminar el documento anterior.', 'error');
              }
            }
          });
          }
        });
        } else {

          this.archivoPDF3 = file;
          this.pdfURL3 = pdfSafeUrl;
          // No había documento previo, subir directamente
          this.subirDocumento(rfc, idDocumentoTramite, file);
        }
    }
  }

  // Método para manejo de evento al seleccionar
  archivoSelecionadoPDF3(event: Event, index:number): void {
  }

  // Método para abrir el PDF en nueva ventana
  abrirPDFNewVentana3(): void {
    if (this.pdfURL3) {
      const url = this.pdfURL3 as SafeResourceUrl;
      //const url = URL.createObjectURL(this.archivoPDF3);
      window.open((url as any).changingThisBreaksApplicationSecurity, '_blank');
    } else {
      Swal.fire({
        icon: 'warning',
        title: '¡Aviso!',
        text: 'Para visualizar el documento, primero debes seleccionar uno.',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#A11A5C',
      });
    }
  }

  //********************************** REPUVE *********************************************//

  onFileSelecteded4(input: HTMLInputElement, idDocumentoTramite: number): void {
    const file = input.files?.[0];
    const maxSizeMB = 2;
    const maxSizeBytes = maxSizeMB * 1024 * 1024;

    if (file) {
      if (file.type !== 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Tipo de archivo no válido',
          text: 'Por favor selecciona un archivo PDF.',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      if (file.size > maxSizeBytes) {
        Swal.fire({
          icon: 'error',
          title: 'Archivo demasiado grande',
          text: `El archivo supera el límite de ${maxSizeMB} MB.`,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      const datosPersona = this.SegundoGrupo.getRawValue();

      const rfc = datosPersona.rfc || '';
      
      const objectUrl = URL.createObjectURL(file);
      const pdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);

      //const existente  = this.documentoList.find(doc => doc.idDocumentoTramite === idDocumentoTramite);

       // Buscar si ya hay documento anterior cargado para este tipo
        const existente = this.documentoList.find(doc => doc.idDocumentoTramite === idDocumentoTramite);

        if (existente) {

          Swal.fire({
          title: '¿Reemplazar archivo?',
          text: `Ya existe un archivo para "REPUVE". ¿Deseas eliminar el anterior y subir el nuevo?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#41bd00',
          cancelButtonColor: '#C71128',
          confirmButtonText: 'Sí, reemplazar',
          cancelButtonText: 'No, cancelar'
          }).then((result) =>{
            if(result.isConfirmed){
              this.archivoPDF4 = file;
              this.pdfURL4 = pdfSafeUrl;
              // Llamar a servicio para eliminar el documento existente
          this.eliminarDocumentosService.eliminarDocumentos(existente.idDocumento, rfc, existente.nombreDocumento).subscribe({
            next: (res) => {
              if (res.status === 204) {

                this.subirDocumento(rfc, idDocumentoTramite, file); // 👈 Subir nuevo PDF
              } else {
                Swal.fire('Error', 'No se pudo eliminar el documento anterior.', 'error');
              }
            },
            error: (err) => {
              if (err.status === 404) {

                this.subirDocumento(rfc, idDocumentoTramite, file); // 👈 Subir de todos modos
              } else {
                Swal.fire('Error', 'Error al eliminar el documento anterior.', 'error');
              }
            }
          });
            }
          })

          
        } else {
          this.archivoPDF4 = file;
          this.pdfURL4 = pdfSafeUrl;
          // No había documento previo, subir directamente
          this.subirDocumento(rfc, idDocumentoTramite, file);
        }
    }
  }

  // Evento de selección (opcional)
  archivoSelecionadoPDF4(event: Event, index:number): void {
  }

  // Abrir PDF en nueva pestaña
  abrirPDFNewVentana4(): void {
    if (this.pdfURL4) {
       const url = this.pdfURL4 as SafeResourceUrl;
     window.open((url as any).changingThisBreaksApplicationSecurity, '_blank');
    } else {
      Swal.fire({
        icon: 'warning',
        title: '¡Aviso!',
        text: 'Para visualizar el documento, primero debes seleccionar uno.',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#A11A5C',
      });
    }
  }

  //********************************FUNCIONES*********************************************** */

  // Méto do que "transfiere" valor automáticamente del RFC al CURP

  pasarValorRfcACurp(): void {
    const rfc = this.SegundoGrupo.get('rfc')?.value;

    if (rfc && rfc.length >= 10) {
      const curpParcial = rfc.substr(0, 10).toUpperCase(); // Convertir a mayúsculas
      this.SegundoGrupo.get('curp')?.setValue(curpParcial);
    } else {
      // Caso en que el RFC no tenga los caracteres necesarios
      this.SegundoGrupo.get('curp')?.setValue('');
    }
  }

  // funcion para abrir modal curp

  modalCURP() {
    Swal.fire({
      background: 'rgba(161, 26, 92)',
      imageUrl: '/assets/img/imagenesCuerpo/CURP.png',
      imageWidth: '95%',
      imageHeight: 'auto',
      showCloseButton: true,
      showConfirmButton: false,
      width: '60%',
      showClass: {
        popup: `
          animate__animated
          animate__fadeInUp
          animate__faster
        `,
      },
      hideClass: {
        popup: `
                animate__animated
                animate__fadeOutDown
                animate__faster
              `,
      },
    });
  }

  // funcion para abrir modal rfc

  modalRFCFISICA() {
    Swal.fire({
      background: 'rgba(161, 26, 92)',
      imageUrl: '/assets/img/imagenesCuerpo/RFCFISICA.png',
      imageWidth: '95%',
      imageHeight: 'auto',
      showCloseButton: true,
      showConfirmButton: false,
      width: '60%',
      showClass: {
        popup: `
          animate__animated
          animate__fadeInUp
          animate__faster
        `,
      },
      hideClass: {
        popup: `
                animate__animated
                animate__fadeOutDown
                animate__faster
              `,
      },
    });
  }

  // funcion para descargar documento



extractBirthday(): void {
    const rfc: string = this.SegundoGrupo.get('rfc')?.value;

    if (rfc && rfc.length >= 10) {
      // Obtener el año (posiciones 5 y 6 del RFC)
      let anio: string = rfc.substring(4, 6).trim();
      const anioInt: number = parseInt(anio, 10);

      if (anioInt > new Date().getFullYear() % 100 || anio === '00') {
        anio = (anio === '00') ? '2000' : '19' + anio;
      } else {
        anio = '20' + anio;
      }

      // Obtener mes y día
      const mes: string = rfc.substring(6, 8).trim();
      const dia: string = rfc.substring(8, 10).trim();

      const fechaNacimiento = `${anio}-${mes}-${dia}`;
            this.SegundoGrupo.get('fechaNacimiento')?.setValue(fechaNacimiento);
    } else {
      this.SegundoGrupo.get('fechaNacimiento')?.setValue('');
    }
  }


  extraerSexoDesdeCurp(): void {
    const curp: string = this.SegundoGrupo.get('curp')?.value;

    if (curp && curp.length >= 18) {
      const sexo = curp.charAt(10).toUpperCase();

      if (sexo === 'H') {
        this.SegundoGrupo.get('sexo')?.setValue('M');
      } else if (sexo === 'M') {
        this.SegundoGrupo.get('sexo')?.setValue('F');
      } else {
        this.SegundoGrupo.get('sexo')?.setValue('');
      }
    } else {
      this.SegundoGrupo.get('sexo')?.setValue('');
    }
  }
}
